import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPencilIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 15 15.1",
	style: { enableBackground: "new 0 0 15 15.1" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.pencil-icon-st0{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;}\n"
	}), /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
		className: "pencil-icon-st0",
		d: "M4.8,14.6H1.1c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.1-0.2-0.3-0.2-0.4v-3.5c0-0.1,0-0.2,0-0.2 c0-0.1,0.1-0.1,0.1-0.2L10,0.7c0.1-0.1,0.3-0.2,0.4-0.2s0.3,0.1,0.4,0.2l3.5,3.5c0.1,0.1,0.2,0.3,0.2,0.4c0,0.1-0.1,0.3-0.2,0.4 L4.8,14.6z"
	}), /* @__PURE__ */ _jsx("path", {
		className: "pencil-icon-st0",
		d: "M7.9,2.7l4.4,4.4"
	})] }) }) })]
});
export default SvgPencilIcon;
